import React, { Component } from "react";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import UploadManufacturer from "./upload";

import { dateTimeFormatter } from "../../../common/utils";

class SettingsManufacturer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
    this.handleClose = this.handleClose.bind(this);
  }
  showModal(e) {
    this.setState({
      modal: true
    });
  }
  handleClose(e) {
    this.setState({
      modal: false
    });
  }
  render() {
    const { classes, translate, uploadManufacturerDb, log } = this.props;
    const { modal } = this.state;

    let $modal = modal ? (
      <UploadManufacturer
        translate={translate}
        onClose={this.handleClose}
        uploadManufacturerDb={uploadManufacturerDb}
      />
    ) : null;

    return (
      <div>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Typography type="headline" color="inherit">
                {translate("settings_manufacturerdb")}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.info}>
              <Typography type="subheading" color="inherit">
                {translate("settings_cableinfofile_label")}
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("profile_name")}:
                <b>{log && log.cable ? log.cable.name : ""}</b>
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("settings_date_uploaded")}
                <b>
                  {log && log.cable
                    ? dateTimeFormatter(log.cable.createdat)
                    : ""}
                </b>
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("settings_version_number")}
                <b>{log && log.cable ? log.cable.Version : ""}</b>
              </Typography>
              <Typography type="subheading" color="inherit">
                {translate("settings_connectorinfofile_label")}
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("profile_name")}:
                <b>{log && log.connector ? log.connector.name : ""}</b>
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("settings_date_uploaded")}
                <b>
                  {log && log.connector
                    ? dateTimeFormatter(log.connector.createdat)
                    : ""}
                </b>
              </Typography>
              <Typography
                type="caption"
                color="inherit"
                className={classes.uppercase}
              >
                {translate("settings_version_number")}
                <b>{log && log.connector ? log.connector.Version : ""}</b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                raised
                fullWidth
                className={classes.orangeButton}
                onClick={e => this.showModal(e)}
              >
                {translate("settings_upload")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
        {$modal}
      </div>
    );
  }
}

export default withStyles(styles)(SettingsManufacturer);
